var map = {
	"./Bronze.svg": 885,
	"./Diamond.svg": 886,
	"./Gold.svg": 887,
	"./Silver.svg": 888,
	"./company-default.png": 157,
	"./dummy.jpg": 217,
	"./dummy_profile.jpg": 115,
	"./icons8-whatsapp.svg": 85,
	"./invoice-sign": 258,
	"./invoice-sign.js": 258,
	"./videoimg.png": 271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;